import { NO_PAYMENT_METHOD_SELECTED } from '~shared/features/checkout/constants';
import { getOrder } from '~shared/features/checkout/selectors/getOrder';
import { getIsPaymentMethodRequired } from '~shared/features/checkout/selectors/getPaymentBreakdown';
import { type ValidationError } from '~shared/features/checkout/types';
import { PAYMENT_METHOD_DATA_TYPES } from '~shared/features/payment-methods/constants';
import { getPaymentMethods } from '~shared/features/payment-methods/selectors/getPaymentMethods';
import { getIsSplitPaymentEnabled } from '~shared/features/ui/selectors/getCart';
import { useSelectorShared } from '~shared/store';
import { type PaymentMethod } from '~shared/types';

export const isValidPaymentMethod = (
  paymentMethodID: number | null | undefined,
  paymentMethods: PaymentMethod[],
  isSplitPaymentEnabled?: boolean,
) =>
  !!paymentMethods.find(
    (paymentMethod) =>
      paymentMethod.id === paymentMethodID &&
      (!isSplitPaymentEnabled || paymentMethod.type !== PAYMENT_METHOD_DATA_TYPES.PLAID_DATA),
  );

export const useCheckoutPaymentMethodErrors = () => {
  const paymentMethods = useSelectorShared(getPaymentMethods);
  const isPaymentMethodRequired = useSelectorShared(getIsPaymentMethodRequired);
  const isSplitPaymentEnabled = useSelectorShared(getIsSplitPaymentEnabled);
  const order = useSelectorShared(getOrder);
  const { payment_method_id: paymentMethodID, shipment_payment_methods: shipmentPaymentMethods } = order;

  const errors: ValidationError[] = [];

  // eslint-disable-next-line sonarjs/no-collapsible-if
  if (isPaymentMethodRequired) {
    if (
      !isValidPaymentMethod(paymentMethodID, paymentMethods, isSplitPaymentEnabled) &&
      !shipmentPaymentMethods?.length
    ) {
      errors.push({
        key: NO_PAYMENT_METHOD_SELECTED,
        message: 'Please select a payment method for your medications.',
      });
    }
  }

  return { paymentMethodValidationErrors: errors };
};
